import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { IconStyled, SocialNetworkContainer } from './SocialNetworksBPC.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksBPC = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faFacebook}
      link="https://www.facebook.com/profile.php?id=61571981506831"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://www.instagram.com/safira_sdvm"
      hasMarginRight
    />
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/safira-sdvm"
    />
  </SocialNetworkContainer>
);
